import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "./store"
import "./index.css"
import { BrowserRouter } from "react-router-dom"
import { ThemeProvider as JssThemeProvider } from "react-jss"
import { ThemeProvider } from "@mui/material/styles"
import { theme as customTheme } from "./util/theme"
import { theme } from "./util/CustomTheme"
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react"
// import { initializeMsalInstance, msalInstance } from "./auth/msalInstance"
import { AppRoutes } from "./AppRoutes"
import { ErrorBoundary } from "react-error-boundary"
import { CustomErrorMsg } from "./components/CustomErrorMsg"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionType,
} from "@azure/msal-browser"
import { loginRequest } from "./auth/authConfig"
import AuthenticationProgress from "./components/AuthenticationProgress"
import CustomLoader from "./components/CustomLoader"
import CustomSnackBar from "./components/CustomSnackBar"
import { msalInstance } from "./msalInstance"

// Initialize the MSAL (Microsoft Authentication Library) instance
msalInstance.initialize().then(() => {
  // Get all accounts currently logged in
  const accounts = msalInstance.getAllAccounts()

  // If there are any accounts, set the first account as the active account
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  // Add an event listener to handle MSAL events (e.g., login success)
  msalInstance.addEventCallback((event: EventMessage) => {
    // If the event is a login success, set the active account to the one from the payload
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult
      msalInstance.setActiveAccount(payload.account)
    }
  })

  // Get the root element where the React app will be rendered
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  )

  // Render the React application inside the root element
  root.render(

      <BrowserRouter>
        <Provider store={store}>
          {/* Redux store provider */}
          <ThemeProvider theme={theme}>
            {/* Main theme provider */}
            <JssThemeProvider theme={customTheme}>
              {/* JSS theme provider */}
              <ErrorBoundary fallback={<div></div>}>
                <MsalProvider instance={msalInstance}>
                  {/* MSAL provider for authentication */}
                  <MsalAuthenticationTemplate
                    interactionType={InteractionType.Redirect}
                    authenticationRequest={loginRequest}
                    //  Error component
                    errorComponent={CustomErrorMsg}
                    // Loading component
                    loadingComponent={AuthenticationProgress}
                  >
                    <ErrorBoundary fallback={<CustomErrorMsg />}>
                      {/* Nested error boundary */}
                      {/* Custom components for loader, snackbar, and toast notifications */}
                      <CustomLoader />
                      <CustomSnackBar />
                      <ToastContainer autoClose={2000} />
                      <AppRoutes /> {/* Main application routes */}
                    </ErrorBoundary>
                  </MsalAuthenticationTemplate>
                </MsalProvider>
              </ErrorBoundary>
            </JssThemeProvider>
          </ThemeProvider>
        </Provider>
      </BrowserRouter>
  )
})
